<p-toast></p-toast>
<div class="contacts-dashboard-container">
  <div class="dashboard-content">
    <div class="dashboard-header">
      <div class="header-content">
        <h1>Contacts Ringover</h1>
        <p class="dashboard-subtitle">{{ contacts.length }} contact(s) synchronisé(s)</p>
      </div>
      <div class="header-actions">
        <p-button 
          label="Synchroniser avec Ringover" 
          icon="pi pi-sync" 
          styleClass="p-button-primary" 
          [loading]="isSyncing" 
          (onClick)="syncContacts()">
        </p-button>
      </div>
    </div>

    <p-card styleClass="table-card">
      <p-table 
        #dt 
        [value]="contacts" 
        [rows]="10" 
        [paginator]="true" 
        [globalFilterFields]="['nom', 'prenom', 'societe', 'telephone', 'email']"
        [loading]="isLoading"
        [rowHover]="true"
        dataKey="id"
        currentPageReportTemplate="Affichage {first} à {last} sur {totalRecords} contacts"
        [showCurrentPageReport]="true">
        
        <ng-template pTemplate="caption">
          <div class="flex align-items-center justify-content-between">
            <h5 class="m-0">Liste des contacts</h5>
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Rechercher..." />
            </span>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="nom">Nom <p-sortIcon field="nom"></p-sortIcon></th>
            <th pSortableColumn="prenom">Prénom <p-sortIcon field="prenom"></p-sortIcon></th>
            <th pSortableColumn="societe">Société <p-sortIcon field="societe"></p-sortIcon></th>
            <th pSortableColumn="telephone">Téléphone <p-sortIcon field="telephone"></p-sortIcon></th>
            <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
            <th>Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-contact>
          <tr>
            <td>{{ contact.nom }}</td>
            <td>{{ contact.prenom }}</td>
            <td>{{ contact.societe || '-' }}</td>
            <td>
              <span class="phone-container" *ngIf="contact.telephone">
                {{ contact.telephone }}
              </span>
              <span class="text-muted" *ngIf="!contact.telephone">-</span>
            </td>
            <td>{{ contact.email || '-' }}</td>
            <td>
              <app-ringover-widget *ngIf="contact.telephone" [telephone]="contact.telephone"></app-ringover-widget>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center p-4">
              Aucun contact trouvé. Cliquez sur "Synchroniser avec Ringover" pour importer vos contacts.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
